export default __webpack_public_path__ + "static/media/news-10.74855836.jpg";